import { Fireworks } from "fireworks-js";
import React, { useEffect, useRef, useState } from "react";
import { FaAngleRight, FaInfoCircle } from "react-icons/fa";
import { FiExternalLink, FiTrash2 } from 'react-icons/fi';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { Avatar, Badge, Box, Button, Divider, Paragraph, Text, useColorMode } from "theme-ui";
import { getGamificationCriteriaUser } from "../../store/actions/Rating.Action";
import { getAllGamificationTodosCount } from "../../store/actions/user.action";
import { gradients } from "../../utils/CustomHandler";
import { bucketUrl } from "../../utils/global";
import calender from "../assets/images/calendar-2.svg";
import notifications from "../assets/images/notification.svg";
import CustomArrow from "./Dropdown";
import { BsMoon, BsSun } from "react-icons/bs";
import { SearchBar } from "./SearchBar";
import { Overlay, Popover } from "react-bootstrap";
import moment from "moment";
import { getAllUnreadNotificationByEmail, updateBulkNotification } from "../../store/actions/login.action";
import { ActionUpdateById } from "../../store/actions/CommonAction";
import { LuInfo } from "react-icons/lu";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import toast from "react-hot-toast";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../firebase";

interface TopBarProps {
    collapsed?: boolean;
}

const truncateString = (str: string, num: number) => {
    if (str.length > num) {
        return str.slice(0, num) + '...';
    }
    return str;
};
const Topbar: React.FC<TopBarProps> = ({ collapsed }): JSX.Element => {
    const dispatch = useDispatch();
    const { auther, allUnreadNotifications } = useSelector((state: any) => state.auth);
    const { gamificationCount } = useSelector((state: any) => state.user);
    const { loader, earnedBadges } = useSelector((state: any) => state.rating);
    const unread = allUnreadNotifications?.data?.filter((n: any) => !n.isSeen) || [];
    const read = allUnreadNotifications?.data?.filter((n: any) => n.isSeen) || [];
    const sortedNotifications = [...unread, ...read];
    const unseenCount = allUnreadNotifications?.data?.filter((n: any) => !n.isSeen).length || 0;
    const [showFireworks, setShowFireworks] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState<any>(null);
    const targetRef = useRef<HTMLElement | null>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const fireworksRef = useRef<HTMLDivElement | null>(null);
    const [colorMode, setColorMode] = useColorMode();
    const navbarBackground = colorMode === 'light' ? '#ffffff' : '#20283c';
    const BgNotification = colorMode === 'light' ? '#ffffff' : '#282e42';
    const iconColor = colorMode === 'light' ? '#000000' : '#ffffff';

    useEffect(() => {
        dispatch(getAllGamificationTodosCount())

        dispatch(getGamificationCriteriaUser())

    }, [])

    const email = auther?.Email;

    const generateDottedBorder = (checklist: any[]) => {
        const totalCount = gamificationCount?.data?.totalchecklistCount;
        const segmentSize = 360 / totalCount;
        const gapSize = 8;
        const adjustedSegmentSize = segmentSize - gapSize;
        if (!checklist || totalCount === 0) return "gray";

        const segments = checklist.map((item, index) => {
            const startAngle = index * segmentSize;
            const endAngle = startAngle + adjustedSegmentSize;
            const color = item.isChecked ? (item.color) : 'gray';
            return `${color} ${startAngle}deg ${endAngle}deg,transparent ${endAngle}deg ${startAngle + segmentSize}deg`;
        });

        return `${segments.join(", ")}`;
    };

    const todoChecklist = gamificationCount?.data?.checklist?.todoChecklist || [];
    const startFireworks = () => {
        if (fireworksRef.current) {
            const container = fireworksRef.current;
            const fireworks = new Fireworks(container, {
                hue: { min: 0, max: 360 },
                delay: { min: 30, max: 60 },
                intensity: 15,
                explosion: 4,
                traceLength: 3,
                traceSpeed: 5,
                gravity: 1,
                boundaries: {
                    x: 0,
                    y: 0,
                    width: 100,
                    height: 100
                },
                autoresize: false
            });

            fireworks.start();
            setTimeout(() => {
                fireworks.stop();
                setShowFireworks(false);
            }, 5000);
        }
    };

    // Check if all tasks are completed and trigger fireworks
    useEffect(() => {
        const validPaths = ["/my-todo", "/assigned-todo", "/todos"];
        if (validPaths.includes(location.pathname) && todoChecklist.length > 0 && todoChecklist.every((item: any) => item.isChecked)) {
            setShowFireworks(true);
            startFireworks();
        }
    }, [todoChecklist, location.pathname]);
    const NextArrow = ({ onClick }: any) => (
        <Box
            onClick={onClick}
            sx={{
                transform: 'translateX(415px) translateY(-32px)',
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                // display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10,
                // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                // "&:hover": { background: "#999" }
            }}
        >
            <FaAngleRight color={colorMode === "light" ? "black" : "white"} size={16}></FaAngleRight>
        </Box>
    );
    const settings = {
        dots: false,
        infinite: earnedBadges?.data?.filter((badge: any) => badge?.badgeId !== null).length > 1,
        speed: 800,
        // autoplay: true,
        // autoplaySpeed: 4000,
        nextArrow: <NextArrow />,
        // slidesToShow: 4,
        slidesToScroll: 2,
        rtl: false
    };
    const handleBadgeclick = () => {
        navigate('/badges-details')
    }
    const validBadge = earnedBadges?.data?.filter((badge: any) => badge?.badgeId !== null)
    const [isfetchNotification, setIsfetchNotification] = useState(false)

    useEffect(() => {

        setTimeout(() => {
            if (email && !isfetchNotification) {
                dispatch(getAllUnreadNotificationByEmail(email))
                setIsfetchNotification(!isfetchNotification)
            }
        }, 2000);
    }, [email, isfetchNotification])
    const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
        targetRef.current = event.target as HTMLElement;
        setIsPopoverOpen(!isPopoverOpen);
    };

    const markNotificationAsSeen = (item: any, callback?: () => void) => {
        if (!item.isSeen && item._id) {
            dispatch(
                ActionUpdateById(
                    {
                        Query: `/notification/update-notification-by-Id/${item._id}`,
                        obj: { isSeen: true },
                    },
                    (res: any) => {
                        dispatch(getAllUnreadNotificationByEmail(email));
                        if (res?.status && callback) callback();
                    }
                )
            );
        } else {
            if (callback) callback();
        }
    };
    const handleNotificationRedirect = (
        item: any,
        fullUrl: string | undefined,
        options?: { newTab?: boolean; closePopover?: boolean }
    ) => {
        markNotificationAsSeen(item, () => {
            if (options?.closePopover) setIsPopoverOpen(false);
            if (fullUrl) {
                const urlObj = new URL(fullUrl, window.location.origin);
                urlObj.searchParams.set('isNotification', 'true');
                urlObj.hash = ''; // Ensure that the hash is cleared

                if (options?.newTab) {
                    urlObj.searchParams.set('fromTab', 'new');
                    const finalUrl = urlObj.pathname + urlObj.search;
                    window.open(finalUrl, '_blank', 'noopener,noreferrer');
                } else {
                    const finalUrl = urlObj.pathname + urlObj.search;
                    // Save the previous route for history

                    sessionStorage.setItem('prevRoute', location.pathname + location.search);
                    window.location.replace(finalUrl);


                }
            }
        });
    };

    const handleUpdateNotification = (item: any) => {
        const payload = { isRead: true };
        if (item._id) {
            dispatch(
                ActionUpdateById(
                    {
                        Query: `/notification/update-notification-by-Id/${item._id}`,
                        obj: payload,
                    },
                    handleResponse
                )
            );
        }
    };
    const handleResponse = (res: any) => {
        if (res.status) {
            dispatch(getAllUnreadNotificationByEmail(email));
        }
    };
    const handleMarkAllAsRead = () => {
        const notificationIds = allUnreadNotifications?.data?.map((notification: any) => notification?._id);

        if (notificationIds?.length > 0) {
            const payload = {
                ids: notificationIds,
                updateData: {
                    isRead: true
                }
            };

            // Dispatch the bulk update action to mark all as read
            dispatch(updateBulkNotification(payload));
            setIsPopoverOpen(false)
            dispatch(getAllUnreadNotificationByEmail(email))

        }
    };

    // Handler for trash icon click
    const handleTrashClick = (item: any) => {
        setSelectedNotification(item);
        setShowDeleteConfirmation(true);
        setIsPopoverOpen(false);
    };

    const confirmDeleteNotification = () => {
        if (selectedNotification) {
            handleUpdateNotification(selectedNotification);
        }
        setShowDeleteConfirmation(false);
        setSelectedNotification(null);
        // Do not show popover again if 'Yes' is clicked
    };

    const cancelDeleteNotification = () => {
        setShowDeleteConfirmation(false);
        setSelectedNotification(null);
        setIsPopoverOpen(true); // Show popover again if 'No' is clicked
    };
    const closeButton = (
        <button
            type="button"
            aria-label="Close"
            onClick={cancelDeleteNotification}
            style={{
                color: colorMode === 'dark' ? '#fff' : '#000',
                background: 'transparent',
                border: 'none',
                fontSize: 23,
                lineHeight: 1,
                padding: 0,
                cursor: 'pointer'
            }}
        >
            <span aria-hidden="true">&times;</span>
        </button>
    );
    useEffect(() => {
        const unsubscribe = onMessage(messaging, (payload) => {
            const { title, body } = payload.notification || {};
            setIsfetchNotification(false);
            toast.custom((t) => (
                <div className={`custom-toast ${t.visible ? "enter" : "leave"}`}>
                    <div className="left-border" />
                    <div className="toast-content">
                        <div className="toast-title">
                            <span className="pe-2">
                                <FaInfoCircle style={{ color: "#3b82f6" }} size={17} />
                            </span>
                            {title || "Notification"}
                        </div>
                        <div className="toast-message">{body || "You have a new message"}</div>
                    </div>
                    <button className="close-button" onClick={() => toast.dismiss(t.id)}>×</button>
                </div>
            ));

            // ✅ Call API when notification is received


        });

        return () => unsubscribe();
    }, [dispatch, email]);

    const getNotificationUrl = (item: any) => {
        let url = '';
        let query = '';
        const lowerMessage = item.message?.toLowerCase() || '';
        const stageKeywords = ['background change', 'plan check', 'revision'];
        const taskKeywords = ['need info', 'needed info reply', 'blocked by trade', 'waiting for trade'];
        const newInfoMessages = ['new information has been added', 'new info has been added. please review.'];
        const isDueDate = lowerMessage.includes('due date');
        const isNewStage = lowerMessage.includes('new stage') && lowerMessage.includes('active');
        const matchedStage = stageKeywords.find(keyword => lowerMessage.includes(keyword));
        const stageId = item.notifiedStageId || item.stageId;
        if ((matchedStage || isDueDate || isNewStage) && stageId) {
            query = matchedStage ? `?highlights=${encodeURIComponent(matchedStage)}` : '';
            url = `/edit-stages/${stageId}`;
        } else {
            if (newInfoMessages.some(msg => lowerMessage.includes(msg))) {
                query = '?highlights=New%20Info%20Added';
            } else if (item.type === 'Internal Waiting For Trade') {
                query = '?highlights=Waiting%20for%20Trade';
            } else {
                const matchedTask = taskKeywords.find(keyword => lowerMessage.includes(keyword));
                if (matchedTask) {
                    let taskHighlight = matchedTask;
                    if (matchedTask === 'need info') {
                        taskHighlight = 'Need Info';
                    } else if (matchedTask === 'needed info reply') {
                        taskHighlight = 'Needed Info Reply';
                    } else if (matchedTask === 'blocked by trade') {
                        taskHighlight = 'Blocked By Trade';
                    } else if (matchedTask === 'waiting for trade') {
                        taskHighlight = 'Waiting for Trade';
                    }
                    query = `?highlights=${encodeURIComponent(taskHighlight)}`;
                    if (lowerMessage.includes('reply')) {
                        query += `&openReply=true`;
                    }
                }
            }
            const taskId = item.notifiedTaskId || item.taskId;
            if (item.frontAppId) {
                url = `/front-app/pending-items`;
            } else if (taskId) {
                url = `/edit-task/${taskId}`;
            } else if (stageId) {
                url = `/edit-stages/${stageId}`;
            }
        }
        if (!url && item.projectId) {
            url = `/edit-project/${item.projectId?._id}`;
        }
        return url ? `${url}${query}` : undefined;
    };

    return (
        <>
            {/* <BrowserView> */}
            <div className={`navbar p-0 navbar-inverse navbar-fixed-top ${collapsed ? "collapsed" : ""}`} style={{ backgroundColor: navbarBackground, transition: 'background-color 0.3s ease' }}>
                <div className="container-fluid revstyle" style={{ flexWrap: 'nowrap' }} >
                    <div className="navbar-brand">
                        <SearchBar />
                    </div>
                    <div className="d-flex justify-content-end align-items-center nav-style topbar-slider-div" >
                        <button
                            onClick={() => setColorMode(colorMode === 'light' ? 'dark' : 'light')}
                            style={{ background: `none`, border: 'none', borderRadius: '50%', cursor: 'pointer', margin: '0 10px', color: iconColor }}
                            title={colorMode === 'light' ? 'Switch to Dark mode' : 'Switch to Light mode'}
                        >
                            {colorMode === 'light' ? <BsMoon size={22} /> : <BsSun size={22} />}
                        </button>
                        <img className="img" alt="calender" src={calender} style={{ margin: "0 10px" }} />
                        <Box sx={{ position: 'relative', cursor: 'pointer', backgroundColor: colorMode === 'light' ? 'white' : '#20283c' }} onClick={handleNotificationClick}>
                            <img
                                className="mask-group"
                                alt="Notifications"
                                src={notifications}
                                style={{ margin: '0 10px' }}
                            />
                            {unseenCount > 0 && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '-2px',
                                        right: '3px',
                                        backgroundColor: 'primary',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: '17px',
                                        height: '17px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        fontSize: '11px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {unseenCount}
                                </Box>
                            )}
                        </Box>

                        <Overlay
                            show={isPopoverOpen}
                            target={targetRef.current}
                            placement="bottom"
                            containerPadding={10}
                            rootClose
                            onHide={() => setIsPopoverOpen(false)}
                        >
                            <Popover id="popover-basic" style={{ minWidth: '280px', backgroundColor: colorMode === 'light' ? 'white' : '#282e42' }} className="mt-2">
                                {/* <Popover.Header as="h3">Notifications</Popover.Header> */}
                                <Popover.Body>
                                    <Box sx={{ maxHeight: '250px', overflowY: 'auto', scrollbarWidth: 'thin', '&::-webkit-scrollbar': { width: '6px' }, '&::-webkit-scrollbar-thumb': { background: '#ccc', borderRadius: '6px' } }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '12px', backgroundColor: colorMode === 'light' ? 'white' : '#282e42' }}>
                                            <Box sx={{ fontWeight: 'bold', color: colorMode === 'light' ? 'black' : 'white' }}>Notifications</Box>
                                            <Badge sx={{

                                                ml: 2,
                                                backgroundColor: 'primary',
                                                color: 'white',
                                                borderRadius: '50%',
                                                width: '17px',
                                                height: '17px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                fontSize: '11px',
                                                fontWeight: 'bold',
                                            }}>{unseenCount}</Badge>
                                        </Box>
                                        <Divider sx={{ color: colorMode === 'light' ? '' : 'white' }} />

                                        {sortedNotifications?.length > 0 ? (
                                            sortedNotifications.map((item: any) => {
                                                const fullUrl = getNotificationUrl(item);
                                                return (
                                                    <a
                                                        key={item._id}
                                                        href="#"
                                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                                    >
                                                        <Box
                                                            className="notification-card"
                                                            sx={{
                                                                padding: '9px',
                                                                cursor: 'pointer',
                                                                position: 'relative',
                                                                backgroundColor: item.isSeen && colorMode === 'light' ? '#f7f7f7' : BgNotification,
                                                                transition: 'background 0.2s',
                                                            }}
                                                            onClick={e => {
                                                                e.stopPropagation();
                                                                handleNotificationRedirect(item, fullUrl, { closePopover: true });
                                                            }}
                                                        >
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <LuInfo size={16} style={{ color: colorMode === 'light' ? 'black' : 'white' }} />
                                                                <Text variant="SelectLabel" sx={{ lineHeight: '15px', mt: 1, ml: 1, color: colorMode === 'light' ? (item.isSeen ? 'muted' : 'black') : (item.isSeen ? 'muted' : 'white') }}>
                                                                    {item.message}
                                                                </Text>
                                                                <Box
                                                                    sx={{
                                                                        ml: 'auto',
                                                                        mt: 1,
                                                                        mr: 1,
                                                                        color: 'black',
                                                                        cursor: 'pointer',
                                                                        '&:hover': { opacity: 0.8 },
                                                                    }}
                                                                    onClick={e => {
                                                                        e.stopPropagation();
                                                                        handleNotificationRedirect(item, fullUrl, { newTab: true });
                                                                    }}
                                                                >
                                                                    <FiExternalLink size={16} style={{ color: colorMode === 'light' ? 'black' : 'blue' }} />
                                                                </Box>
                                                                <Box
                                                                    sx={{
                                                                        ml: 1,
                                                                        mt: 1,
                                                                        mr: 1,
                                                                        color: 'red',
                                                                        cursor: 'pointer',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                    }}
                                                                    onClick={e => { e.stopPropagation(); handleTrashClick(item); }}
                                                                >
                                                                    <FiTrash2 size={16} />
                                                                </Box>
                                                            </Box>
                                                            <Paragraph variant="Poppins14Medium20lh" sx={{ color: 'muted', ml: 3 }}>
                                                                Project: <Text>{item?.projectId?.name}</Text>
                                                            </Paragraph>
                                                            <div style={{ fontSize: '12px', color: 'gray', marginLeft: '15px' }}>
                                                                {moment(item.createdAt).format('MMM DD, LT')}
                                                            </div>
                                                            <hr />
                                                        </Box>
                                                    </a>
                                                );
                                            })
                                        ) : (
                                            <div style={{ color: 'gray' }}>No new notifications.</div>
                                        )}
                                    </Box>
                                    <Button
                                        variant="link"
                                        sx={{ textAlign: 'center', width: '100%' }}
                                        onClick={handleMarkAllAsRead}
                                    >
                                        Delete All
                                    </Button>


                                </Popover.Body>
                            </Popover>
                        </Overlay>
                        {earnedBadges?.data?.length > 0 && (
                            <Box sx={{ width: validBadge?.length === 1 ? "177px !important" : "auto", maxWidth: "450px", overflow: "hidden", px: 3, pt: 3 }}>
                                {/* <Box sx={{ width: "auto", maxWidth: "450px", overflow: "hidden", px: 3, pt: 3 }}> */}
                                <Slider {...settings}
                                    slidesToShow={
                                        earnedBadges?.data?.length === 1
                                            ? 1
                                            : earnedBadges?.data?.length < 4
                                                ? earnedBadges?.data?.length
                                                : 4
                                    }
                                >
                                    {earnedBadges?.data?.filter((badge: any) => badge?.badgeId !== null).map((badge: any, index: number) => {
                                        // console.log('Badge:', badge);
                                        return badge?.badgeId ? (
                                            <Box key={index} sx={{ display: "flex", justifyContent: "center", px: 1, cursor: 'pointer' }} onClick={handleBadgeclick}>
                                                <Badge
                                                    sx={{
                                                        background: gradients[(badge?.badgeId?.name?.toUpperCase() as keyof typeof gradients)] || gradients.default,
                                                        color: "white",
                                                        fontSize: "17px",
                                                        fontWeight: "bold",
                                                        px: '10px',
                                                        py: '6px',
                                                        borderRadius: "12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: 2,
                                                    }}
                                                >
                                                    {badge?.badgeId?.icon && <img title={badge?.badgeId?.name} src={badge.badgeId.icon} style={{ width: '25px', height: '25px' }} />}
                                                    {badge?.badgeCriteria?.icon && (
                                                        <span>
                                                            <img title={badge?.badgeCriteria?.name} src={badge.badgeCriteria.icon} style={{ width: '25px', height: '25px' }} />
                                                        </span>
                                                    )}
                                                </Badge>
                                            </Box>
                                        ) : null;
                                    })}

                                </Slider>
                            </Box>
                        )}

                        <Box className="profile-ring-container" ref={fireworksRef}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                        >
                            {showTooltip && (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "95%",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        backgroundColor: "black",
                                        color: "white",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        transition: "opacity 0.2s ease-in-out",
                                        opacity: showTooltip ? 1 : 0,
                                        zIndex: 10,
                                    }}
                                >
                                    {`Total Todos: ${gamificationCount?.data?.totalchecklistCount || 0}`}
                                </Box>
                            )}
                            {showFireworks && <div className="avatar-fireworks"></div>}
                            <div
                                style={{
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    padding: "10px", // Increased padding to create space between Avatar & Ring
                                    border: "6px solid transparent",
                                    background: `conic-gradient(${generateDottedBorder(todoChecklist)})`,
                                    maskImage: "radial-gradient(circle, rgba(0,0,0,0) 38%, rgba(0,0,0,1) 50%, rgba(0,0,0,0) 60%)",
                                    WebkitMaskImage: "radial-gradient(circle, rgba(0,0,0,0) 38%, rgba(0,0,0,1) 54%, rgba(0,0,0,0) 63%)",
                                }}
                            ></div>
                            {auther?.ProfileImage ? (
                                <Avatar
                                    width={50}
                                    height={50}
                                    variant="profile"
                                    src={`${bucketUrl}${auther?.ProfileImage}`}
                                    sx={{
                                        position: "absolute", backgroundColor: "white", borderRadius: "50%",
                                        padding: '3px'
                                    }}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        position: "absolute",
                                        width: 45,
                                        height: 45,
                                        padding: '3px',
                                        borderRadius: "50%",
                                        backgroundColor: "primary",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: 600,
                                        fontSize: '18px',
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    {auther?.FirstName?.charAt(0)}
                                </Box>
                            )}

                        </Box>
                        <div className="user-info d-flex flex-column justify-content-center mx-1" style={{ color: iconColor }}>
                            <div>{auther?.FirstName} {auther?.LastName || ""}</div>
                            <sub className="mb-1 wrap-after-four" title={auther?.Role?.map((r: any) => r.RoleName).join(", ") || ""}>
                                <b>{truncateString(auther?.Role?.map((r: any) => r.RoleName).join(", ") || "", 20)}</b>
                            </sub>
                            <div>{auther?.Email || ""}</div>
                        </div>
                        <CustomArrow />
                    </div>

                </div>
            </div >

            {/* </BrowserView>
            <MobileView>
                <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '5%' }}>
                    <img className="img" alt="calender" src={calender} style={{ margin: "0 10px" }} />
                    <img className="mask-group" alt="Notifications" src={notifications} style={{ margin: "0 10px" }} />
                    <div className="d-flex align-items-center mt-1">
                        <Avatar src={auther?.ProfileImage} sx={{ backgroundColor: "white" }} />
                        <div className="user-info d-flex flex-column justify-content-center mx-1">
                            <div>{auther?.FirstName} {auther?.LastName || ""}</div>
                            <div>{auther?.Email || ""}</div>
                        </div>
                    </div>
                </div>
                <br />
                <div className="navbar-brand">
                    <SearchBar />
                </div>
            </MobileView> */}

            <Modal isOpen={showDeleteConfirmation} toggle={cancelDeleteNotification} size="sm" centered style={{ zIndex: 9999 }}>
                <ModalHeader toggle={cancelDeleteNotification} close={closeButton} style={{ backgroundColor: colorMode === 'light' ? '#ffffff' : '#323c56', color: colorMode === 'light' ? '#000000' : '#ffffff' }}>Confirm Deletion</ModalHeader>
                <ModalBody style={{ backgroundColor: colorMode === 'light' ? '#ffffff' : '#323c56', color: colorMode === 'light' ? '#000000' : '#ffffff' }}>
                    {`Are you sure you want to delete this notification?`}
                </ModalBody>
                <ModalFooter style={{ backgroundColor: colorMode === 'light' ? '#ffffff' : '#323c56', color: colorMode === 'light' ? '#000000' : '#ffffff' }}>
                    <Button variant="CancelButton" sx={{ mr: 2, cursor: 'pointer' }} onClick={cancelDeleteNotification}>No</Button>
                    <Button type="button" variant="SaveButton" sx={{ cursor: 'pointer' }} onClick={confirmDeleteNotification}>Yes</Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Topbar;
